<template>
  <div class="group-app-item">
    <GroupAppIcon v-for="item in menuItems" :key="item.id" :item="item"/>
  </div>
</template>

<script>
import GroupAppIcon from "@/views/GroupAppIcon.vue";

export default {
  name: "GroupAppItem",
  components: {GroupAppIcon},
  props: {
    item: Object,
  },
  data() {
    return {
      menuItems: []
    }
  },
  created() {
    this.getMenuItems();
  },
  methods: {
    getMenuItems() {
      this.$http('sysMenuCmService.getUserMenu', {menu_id: this.item.params}).then(data => {
        this.menuItems = data || []
      })
    },
  }
}
</script>


<style lang="less" scoped>
.group-app-item {
  display: flex;
  flex-wrap: wrap;
}
</style>
